import Hugo from './Hugo'
export default Hugo
